import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { EMPTY, Observable, Subject, Subscription, timer } from 'rxjs';
import { map, startWith, take } from 'rxjs/operators';

import { Mensagem } from '../_classes/mensagem';
import { MensagemBanco } from '../_classes/mensagem-banco';
import { MenuItem } from '../_classes/menu-item';
import { Servidor } from '../_classes/servidor';
import { EnvService } from '../_servicos/env.service';
import { MensagemService } from '../_servicos/mensagem.service';
import { MenuService } from '../_servicos/menu.service';
import { ModalMensagemBancoService } from '../_servicos/modal-mensagem-banco.service';
import { RamalEditarService } from '../_servicos/ramal-editar-service';
import { RestService } from '../_servicos/rest.service';
import { ServidorService } from '../_servicos/servidor.service';
import { ModalAlertaService } from '../shared/modal-alerta.service';
import { Util } from './../_classes/util';
import { WhatsappSolicitacaoCadastroComponent } from './../whatsapp-solicitacao-cadastro/whatsapp-solicitacao-cadastro.component';

const //nome do recurso utilizado (mesmo que a rota)
  recurso = 'inicio';

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.scss'],
})
export class InicioComponent implements OnInit, OnDestroy {
  iServidor: Subscription;

  //servidorCarregando: boolean = false;
  //@ViewChild('dialogo', { read: TemplateRef }) dialogo: TemplateRef<any>;
  //@ViewChild('template', { read: BsModalRef }) dialogoM: BsModalRef;
  //modalRef: BsModalRef;
  //config = {
  //    keyboard: true,
  //class: 'modal-lg'
  //};

  holeriteTotal = 0;
  holeriteCarregando = false;
  holeriteErros = 0;

  creditoDiaTotal = 0;
  creditoDiaCarregando = false;
  creditoDiaErros = 0;
  dsCreditoDia$: Observable<number>;

  creditoDiaHoraTexto = '';
  redeInterna = false;

  mensagemBancoTotal = 0;
  mensagemBancoCarregando = false;
  mensagemBancoErros = 0;
  dsMensagemBanco$: Observable<MensagemBanco[]>;
  iMensagemBanco: Subscription;

  creditoHoraTotal = 0;
  creditoHoraCarregando = false;
  creditoHoraErros = 0;
  dsCreditoHora$: Observable<number>;

  emailTotal = 0;
  emailCarregando = false;
  emailErros = 0;
  emailSemSenha = true;

  avaliacaoTotal = 0;
  avaliacaoCarregando = false;
  avaliacaoErros = 0;

  ramalTotal = 0;
  ramalCarregando = false;
  ramalErros = 0;
  ramalEditar = false;
  iEditarRamal: Subscription;

  devoMostrarTodosBox = false;
  precisoRecadastrar = false;

  inscricao: Subscription;

  //servidor$: Observable<Servidor>;
  servidor: Servidor = null;

  tempoParaAtualizar = 10000;
  ip: string = null;

  dataSource$: Observable<number>; //usado para matrizes

  erros$ = new Subject<boolean>();
  mostrarAjuda = false;

  rating: number = 0;

  myControl = new UntypedFormControl();

  filteredOptions: Observable<string[]>;

  ultimoErro: any;

  ir(valor) {
    //console.log('valor', valor);
    //console.log('option', this.option);
    const item: MenuItem = this.menuService.itensDeMenu.find(
      (menu) => menu.nome === valor
    ); //.srcElement.innerText
    //);
    //console.log('item', item);
    this.router.navigate([item.link]);
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.menuService.itensDeMenu
      .filter((option: MenuItem) => {
        ////console.log(option);
        return option.nome.toLowerCase().includes(filterValue);
      })
      .map((option) => option.nome);
  }

  constructor(
    private service: RestService,
    private servService: ServidorService,
    private router: Router,
    private ramalEditarService: RamalEditarService,
    private msgService: MensagemService,
    private menuService: MenuService,
    private alertService: ModalAlertaService,
    private mensagemBancoService: ModalMensagemBancoService,
    private dialog: MatDialog,
    private env: EnvService
  ) {}

  navegar(destino: string) {
    if (destino) {
      if (destino.startsWith('www') || destino.startsWith('http')) {
        this.router.navigateByUrl(destino);
      } else {
        this.router.navigate([destino]);
      }
    }
  }

  ngOnInit() {
    //this.menuService.emitirMostrarMenu(true);
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map((value) => this._filter(value))
    );
    //console.log('onInit');
    this.atualizar();
  }

  getCkolling() {
    return this.servidor?.usuario?.dsNomeUsu === 'CKOLLING';
  }

  executarAoCarregarServidor(x: Servidor) {
    //console.log('servidor', this.servidor);
    this.servidor = new Servidor(x);
    this.holeriteAtualizar();
    this.ramalAtualizar();
    //this.emailAtualizar();
    this.avaliacaoAtualizar();
    this.creditoDiaAtualizar();
    this.creditoHoraAtualizar();
    //this.recadastramento();
    this.atualizarEstouNaRedeInterna();
    //ainda não this.mostrarCadastramentoWhatsApp();
    //ainda nao this.mensagemBancoAtualizar();
  }

  pegarIp() {
    this.service.getIp().subscribe(
      (a) => {
        //console.log('IP', a);
        this.ip = a.toString();
      },
      (e) => {
        //console.log('teoricamente erro', e);
        this.ip = e?.error?.text;
      }
    );
  }

  atualizarEstouNaRedeInterna() {
    //console.log('Vou pegar IP: ');
    //this.pegarIp();
    //console.log('Vou verificar se está na rede interna', this.redeInterna);
    this.service.getEstouNaRedeInterna().subscribe(
      (a) => {
        this.redeInterna = true;
        //console.log('retorno OK consulta sobre rede interna', this.redeInterna);
      },
      (e) => {
        //console.log('retorno ERRO consulta sobre rede interna');
        return EMPTY;
      }
    );
  }

  recadastramento() {
    if (!this.erros$) {
      if (this.servidor) {
        this.service
          .getRespondeuRecadastramento(this.servidor.idServidor)
          .pipe(take(1))
          .subscribe((a) => (this.precisoRecadastrar = a));
      }
    }
  }

  atualizar() {
    this.env.bancoConectado = true;
    this.servService
      .getServidorComFuncao2()
      .then(() => this.executarAoCarregarServidor(this.env.servidor))
      .then(() => {
        this.iEditarRamal = this.ramalEditarService.emissor.subscribe(
          (e) => (this.ramalEditar = e)
        );

        this.inscricao = this.msgService.emissorMensagem.subscribe(
          (e: Array<Mensagem>) => {
            this.msgService.mostrarMsg(e);
          }
        );

        this.msgService.emitirMensagensExistentes();
      });
  }

  mensagemBancoAtualizar() {
    timer(this.tempoParaAtualizar).subscribe((v) => {
      this.mensagemBancoCarregando = false;
    });

    if (!(this.mensagemBancoErros === 0 && !this.erros$)) {
      this.mensagemBancoCarregando = true;
      if (this.servidor) {
        //console.log('vou buscar mostrar-mensagem-no-inicio');
        this.iMensagemBanco = this.service
          .listarMensagensNaoLidas(this.servidor.idServidor)
          .subscribe(
            (x: MensagemBanco[]) => {
              //console.log('busquei mostrar-mensagem-no-inicio', x);
              this.mensagemBancoService.mostrar(x);

              if (x) {
                this.mensagemBancoTotal = x.length;
              } else {
                this.mensagemBancoTotal = 0;
              }
              this.mensagemBancoCarregando = false;
            },
            (e) => {
              this.mensagemBancoErros++;
              return EMPTY;
            }
          );
      }
    }
  }

  creditoDiaAtualizar() {
    timer(this.tempoParaAtualizar).subscribe((v) => {
      this.creditoDiaCarregando = false;
    });

    if (!(this.creditoDiaErros === 0 && !this.erros$)) {
      this.creditoDiaCarregando = true;
      if (this.servidor) {
        this.dsCreditoDia$ = this.service
          .getQuantidadeSgrhCreditoDia(this.servidor.idServidor)
          .pipe(take(1));

        this.dsCreditoDia$.subscribe(
          (a) => {
            this.creditoDiaTotal = a;

            this.atualizarCreditoDiasHoras();

            this.creditoDiaCarregando = false;
          },
          (e) => {
            this.creditoDiaErros++;
            this.handleError(e);
            return EMPTY;
          }
        );
      }
    }
  }

  atualizarCreditoDiasHoras() {
    let r: string = '';
    if (this.creditoDiaTotal === 0) {
      r = 'nenhum';
    } else {
      r = this.creditoDiaTotal.toString();
    }
    r = r + ' dia';
    if (this.creditoDiaTotal !== 1) {
      r = r + 's';
    }
    r = r + ' e ';

    if (this.creditoHoraTotal === 0) {
      r = r + 'nenhuma hora';
    } else {
      let hora: number = Math.trunc(this.creditoHoraTotal / 60);
      let min: number = this.creditoHoraTotal - hora * 60;
      if (hora < 10) {
        r = r + ('00' + hora).slice(-2);
      } else {
        r = r + hora;
      }
      r = r + ':' + ('00' + min).slice(-2) + ' horas';
    }

    this.creditoDiaHoraTexto = r;
  }

  alterarRedeInterna() {
    this.redeInterna = !this.redeInterna;
  }

  creditoHoraAtualizar() {
    timer(this.tempoParaAtualizar).subscribe((v) => {
      this.creditoHoraCarregando = false;
    });

    if (!(this.creditoHoraErros === 0 && !this.erros$)) {
      this.creditoHoraCarregando = true;
      if (this.servidor) {
        this.dsCreditoHora$ = this.service
          .getQuantidadeSgrhCreditoHora(this.servidor.idServidor)
          .pipe(take(1));

        this.dsCreditoHora$.subscribe(
          (a) => {
            this.creditoHoraTotal = a;
            this.atualizarCreditoDiasHoras();
            this.creditoHoraCarregando = false;
          },
          (e) => {
            this.creditoHoraErros++;
            this.handleError(e);
            return EMPTY;
          }
        );
      }
    }
  }

  avaliacaoAtualizar() {
    timer(this.tempoParaAtualizar).subscribe((v) => {
      this.avaliacaoCarregando = false;
    });
  }

  mostrarTodos() {
    this.devoMostrarTodosBox = !this.devoMostrarTodosBox;
  }

  ngOnDestroy() {
    //console.log('ngOnDestroy');
    if (this.inscricao) {
      this.inscricao.unsubscribe();
    }
    if (this.iEditarRamal) {
      this.iEditarRamal.unsubscribe();
    }

    if (this.iServidor) {
      this.iServidor.unsubscribe();
    }
    if (this.iMensagemBanco) {
      this.iMensagemBanco.unsubscribe();
    }
  }

  onClick(rating: number): void {
    if (this.rating != rating) {
      this.rating = rating;
    } else {
      this.rating = 0;
    }
  }

  holeriteAtualizar() {
    timer(this.tempoParaAtualizar).subscribe((v) => {
      this.holeriteCarregando = false;
    });
    if (!(this.holeriteErros === 0 && !this.erros$)) {
      this.holeriteCarregando = true;
      if (this.servidor) {
        //this.contaPessoal$ = this.service.getContaCorrente(this.servidor.idServidor).pipe(take(1));
        //this.contaPessoal$.subscribe(a => this.executarAoCarregar(a));

        this.dataSource$ = this.service
          .getQuantidadeHoleriteNovo(this.servidor.nrMatricula)
          .pipe(take(1));

        this.dataSource$.subscribe(
          (a) => {
            this.holeriteTotal = a;
            this.holeriteCarregando = false;
          },
          (e) => {
            this.holeriteErros++;
            this.handleError(e);
            return EMPTY;
          }
        );
      }
    }
  }

  ramalAtualizar() {
    timer(this.tempoParaAtualizar).subscribe((v) => {
      this.ramalCarregando = false;
    });

    if (!(this.ramalErros === 0 && !this.erros$)) {
      this.ramalCarregando = true;
      if (this.servidor) {
        this.ramalTotal = 1;
        this.ramalCarregando = false;
      }
    }
  }

  periodo(dI: Date, dF: Date) {
    return Util.periodoMesAbreviado(dI, dF);
  }

  dataStr(d: Date) {
    return Util.dataMesAbrev(d);
  }

  alterarMostrarAjuda() {
    this.mostrarAjuda = !this.mostrarAjuda;
  }

  mostrarModal2(link: string) {
    //console.log('ERRO2', link);
    this.alertService.mostrarServidorInativo(link);
  }

  mostrarCadastramentoWhatsApp(): void {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      description: 'description',
      longDescription: 'longDescription',
      category: 'category',
    };

    const dialogRef = this.dialog.open(
      WhatsappSolicitacaoCadastroComponent,
      dialogConfig
    );

    dialogRef
      .afterClosed()
      .subscribe((val) => console.log('Dialog output:', val));
  }

  handleError(e: any) {
    //console.log('ERRO na página INICIO');

    if (this.ultimoErro !== e) {
      this.erros$.next(true);
      let mostrarInativo: boolean = false;
      if (e instanceof HttpErrorResponse) {
        if ((e as HttpErrorResponse).status === 0) {
          mostrarInativo = true;
        }
      }
      if (!mostrarInativo) {
        this.alertService.mostrarAlertaPerigo(
          'Erro, tente novamente mais tarde',
          e
        );
      } else {
        //console.log('ERRO1', recurso);
        this.alertService.mostrarServidorInativo(recurso);
      }
    }
  }
}
